import _ from 'underscore';
import Radio from 'backbone.radio';
import NavCollection from '@/collections/nav/nav';
import NavItemView from '@/views/nav/item';

var globalCh = Radio.channel('global');
// Remember the nav collection we create each time the function is run.
var nav_collection = new NavCollection();

function show_development_zone_secondary_nav(product, options) {
    var active = globalCh.request('active_account');
    var primary = globalCh.request('primary_account');

    options = options || {};
    options = _.extend({
        collection: nav_collection,
        category: 'product-secondary',
        childView: NavItemView
    }, options);
    var nav_items = _.compact([ active.permits(primary, 'view_development_devicegroups') && {
        id: 'development_devicegroup',
        title: 'Development Device Groups',
        icon: 'fa ei-icon-development_devicegroup',
        selected: options.selected === 'development_devicegroup',
        action: function show_products() {
            globalCh.request(
                'show_development_devicegroups',
                product,
                'development_devicegroup'
            );
        }
    }
    ]);

    nav_collection.set(nav_items);
    globalCh.request('show_secondary_nav', options);
}
export default show_development_zone_secondary_nav;
